export const TARGOMO_ENVIRONMENT_HEADER = 'x-targomo-environment'

export enum TargomoEnvironment {
  REVIEW = 'review',
  STAGING = 'staging',
  PROD = '',
}
